module.exports = __webpack_public_path__ + "static/media/WhatsAppLogo.5e9db474.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WhatsAppLogo.png
// module id = 628
// module chunks = 0